<template>
  <button
    v-if="isEditable"
    v-edit.floating="editName"
    data-epi-property-render="none"
    class="button button--32 button--editbutton"
    :class=" {
      'button--text-icon': !iconOnly,
      'button--icon': iconOnly
    }"
    type="button"
  >
    <svgicon
      name="Controls/Edit"
    />
    {{ text }}
  </button>
</template>

<script>
import '#/Controls/Edit'

export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: 'Redigera'
    },
    iconOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      editName: 'undefined'
    }
  },

  created () {
    let prefix = this.editPrefix || this.$parent.editPrefix
    if (prefix) {
      this.editName = `${prefix}.${this.id}`
    } else {
      this.editName = this.id
    }
  }
}
</script>

<style lang="scss">
  .button.button--editbutton {
    background-color: $color-blue-dark;
    transition: all 300ms cubic-bezier(0.19, 1, 0.22, 1);
    width: auto;
    margin-right: auto;
    margin-bottom: 1rem;
  }
</style>
